// import {
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    Table,
//    Thead,
//    Tbody,
//    Tr,
//    Th,
//    Td,
//    Input,
//    Button,
//    Switch,
//    FormControl,
//    FormLabel,
//    HStack,
//    Box,
//    useToast,
//    useColorModeValue,
// } from '@chakra-ui/react';
// import { useState, useEffect, useMemo } from 'react';
// import { addReportFormat, getReportFormat, updateReportFormat } from '../../../../redux/actions/reports';
// import { useDispatch } from 'react-redux';

// const ColumnShowHide = ({
//    isOpen,
//    onClose,
//    data = [],
//    onApply,
//    isedit,
//    editData,
//    setShowHideData,
//    selectedFormat = null,
//    FixdefName1,
//    FixdefName2,
//    FixdefName3,
//    onAddFormat,
//    onUpdateFormat,
//    staticOption,
//    dynamicEditOption,
// }) => {
//    const dispatch = useDispatch();
//    const [columns, setColumns] = useState([]);
//    const [formatName, setFormatName] = useState('');
//    const [isLoading, setIsLoading] = useState(false);
//    const toast = useToast();
//     const textColor = useColorModeValue('black', 'white');

//    // Determine which FixdefName to use based on staticOption.value
//    const getFixdefName = () => {
//       const option = staticOption?.value?.toLowerCase()?.trim(); // ✅ Access .value

//       switch (option) {
//          case 'date':
//             return FixdefName1;
//          case 'party':
//             return FixdefName2;
//          case 'broker':
//             return FixdefName3;
//          case 'default':
//             return FixdefName1;
//          default:
//             return staticOption;
//       }
//    };

//    const currentFixdefName = getFixdefName();

//    // Helper function to convert hex color to the format expected by the backend
//    const hexToColorCode = (hex) => {
//       if (!hex || hex === '#000000') return '0xff000000';
//       // Remove # and convert to uppercase
//       const cleanHex = hex.replace('#', '').toUpperCase();
//       return `0xff${cleanHex}`;
//    };

//    // Helper function to convert color code back to hex
//    const colorCodeToHex = (colorCode) => {
//       if (!colorCode || colorCode === '0xff000000') return '#000000';
//       // Remove 0xff prefix and convert to lowercase
//       const hex = colorCode.replace('0xff', '').toLowerCase();
//       return `#${hex}`;
//    };

//    // Memoize the edit mode status and current format
//    const { isEditMode, currentFormat } = useMemo(
//       () => ({
//          isEditMode: Boolean(isedit && editData),
//          currentFormat: selectedFormat,
//       }),
//       [isedit, editData, selectedFormat],
//    );

//    // Initialize data when modal opens or when dependencies change
//    useEffect(() => {
//       if (!isOpen) return;

//       const initializeData = () => {
//          if (isedit && editData) {
//             // Edit mode - populate with selected format data
//             setFormatName(editData.title || editData.defName || '');

//             // Use viewJson if available, otherwise fall back to data prop
//             const sourceColumns = editData.viewJson && Array.isArray(editData.viewJson) ? editData.viewJson : data;

//             const updated = sourceColumns.map((col, index) => ({
//                id: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_') || `col_${index}`, // Add unique ID
//                defName: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_'),
//                title: col.title,
//                isShow: col.isShow !== undefined ? col.isShow : true,
//                orderNo: col.orderNo !== undefined ? col.orderNo : index + 1,
//                flex: col.flex || 1,
//                isBold: col.isBold || false,
//                color: colorCodeToHex(col.color) || '#000000',
//                isItalic: col.isItalic || false,
//             }));

//             setColumns(updated);
//          } else {
//             // Add mode - use fresh data
//             setFormatName('');

//             if (data.length) {
//                const updated = data.map((col, i) => ({
//                   id: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_') || `col_${i}`, // Add unique ID
//                   defName: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_'),
//                   title: col.title,
//                   isShow: col.isShow !== undefined ? col.isShow : true,
//                   orderNo: col.orderNo !== undefined ? col.orderNo : i + 1,
//                   flex: col.flex || 1,
//                   isBold: col.isBold || false,
//                   color: colorCodeToHex(col.color) || '#000000',
//                   isItalic: col.isItalic || false,
//                }));
//                setColumns(updated);
//             } else {
//                setColumns([]);
//             }
//          }
//       };

//       initializeData();
//    }, [isOpen, data, isEditMode, editData]);

//    // Toggle show/hide - now using ID instead of title
//    const handleToggle = (id) => {
//       setColumns((prev) => prev.map((col) => (col.id === id ? { ...col, isShow: !col.isShow } : col)));
//    };

//    // Updated handleFieldChange to use ID instead of title
//    const handleFieldChange = (id, field, value) => {
//       let newValue = value;

//       // Handle different field types
//       if (field === 'orderNo' || field === 'flex') {
//          newValue = parseInt(value) || 0;
//       } else if (field === 'color') {
//          newValue = value; // Keep as hex for display
//       }

//       // First, find the original item and its orderNo
//       const oldItem = columns.find((col) => col.id === id);
//       const oldOrderNo = oldItem?.orderNo;

//       let updated = columns.map((col) => (col.id === id ? { ...col, [field]: newValue } : col));

//       // Handle orderNo swapping logic
//       if (field === 'orderNo') {
//          const newOrderNo = newValue;

//          // Only swap if there's another column with the same orderNo
//          const conflictingColumn = columns.find((col) => col.id !== id && col.orderNo === newOrderNo);

//          if (conflictingColumn) {
//             updated = updated.map((col) => {
//                if (col.id === id) {
//                   return { ...col, orderNo: newOrderNo };
//                } else if (col.orderNo === newOrderNo && col.id !== id) {
//                   return { ...col, orderNo: oldOrderNo };
//                }
//                return col;
//             });
//          }
//       }

//       setColumns(updated);
//    };

//    const handleApply = async () => {
//       if (!formatName.trim()) {
//          toast({
//             title: 'Format name is required',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          return;
//       }

//       // Validate order numbers
//       const orderNumbers = columns.map((col) => col.orderNo);
//       if (new Set(orderNumbers).size !== orderNumbers.length) {
//          toast({
//             title: 'Order numbers must be unique',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          return;
//       }

//       const finalColumns = columns
//          .map((col) => ({
//             defName: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_'),
//             title: col.title,
//             isShow: col.isShow !== false,
//             orderNo: col.orderNo || 0,
//             flex: col.flex || 1,
//             isBold: col.isBold || false,
//             color: hexToColorCode(col.color),
//             isItalic: col.isItalic || false,
//          }))
//          .sort((a, b) => a.orderNo - b.orderNo);

//       setIsLoading(true);

//       try {
//          const isEditing = isedit && editData?.id;

//          if (isEditing) {
//             const updateData = {
//                id: editData.id,
//                defName: dynamicEditOption,
//                title: formatName,
//                viewJson: finalColumns,
//             };

//             // First await the update operation
//             await dispatch(updateReportFormat(updateData));

//             // Then fetch the updated formats
//             await dispatch(getReportFormat());

//             if (onUpdateFormat) {
//                onUpdateFormat(updateData); // Or use response if needed
//             }
//          } else {
//             const newFormat = {
//                defName: currentFixdefName,
//                title: formatName,
//                viewJson: finalColumns,
//             };

//             // First await the add operation
//             await dispatch(addReportFormat(newFormat));

//             // Then fetch the updated formats
//             await dispatch(getReportFormat());

//             if (onAddFormat) {
//                onAddFormat(newFormat); // Or use response if needed
//             }
//          }

//          if (onApply) {
//             onApply(finalColumns);
//          }

//          if (setShowHideData) {
//             setShowHideData(finalColumns);
//          }

//          onClose?.();
//       } catch (error) {
//          console.error('Format operation failed:', error);
//          toast({
//             title: `Error ${isedit ? 'updating' : 'adding'} format`,
//             description: error.message || 'Something went wrong',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       } finally {
//          setIsLoading(false);
//       }
//    };

//    useEffect(() => {
//       if (isOpen && isedit) {
//          setFormatName(editData.title);
//       }
//    }, [isOpen]);

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
//          <ModalOverlay />
//          <ModalContent>
//             <ModalHeader>{isedit ? `Edit Report Format` : 'Add New Report Format'}</ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                <FormControl mb={4}>
//                   <FormLabel>Format Name</FormLabel>
//                   <Input
//                      value={formatName}
//                      onChange={(e) => setFormatName(e.target.value)}
//                      placeholder={isedit ? 'Edit format name' : 'Enter format name'}
//                      disabled={isLoading}
//                   />
//                </FormControl>

//                <Box overflowY="auto" maxH="400px">
//                   <Table variant="simple" size="sm">
//                      <Thead>
//                         <Tr bg="#F1F0E8">
//                            <Th fontWeight="bold">Show</Th>
//                            <Th fontWeight="bold">defName</Th>
//                            <Th fontWeight="bold">Title</Th>
//                            <Th fontWeight="bold">Order No</Th>
//                            <Th fontWeight="bold">Flex</Th>
//                            <Th fontWeight="bold">Bold</Th>
//                            <Th fontWeight="bold">Italic</Th>
//                            <Th fontWeight="bold">Color</Th>
//                         </Tr>
//                      </Thead>
//                      <Tbody>
//                         {columns.length > 0 ? (
//                            columns
//                               .sort((a, b) => (a.orderNo || 0) - (b.orderNo || 0))
//                               .map((item) => (
//                                  <Tr key={item.id}>
//                                     <Td>
//                                        <Switch
//                                           isChecked={item.isShow !== false}
//                                           onChange={() => handleToggle(item.id)}
//                                           disabled={isLoading}
//                                        />
//                                     </Td>
//                                     <Td
//                                        fontWeight={item.isBold ? 'bold' : 'normal'}
//                                        fontStyle={item.isItalic ? 'italic' : 'normal'}
//                                        color={item.color || '#000000'}>
//                                        {item.defName}
//                                     </Td>
//                                     <Td>
//                                        <Input
//                                           size="sm"
//                                           value={item.title}
//                                           onChange={(e) => handleFieldChange(item.id, 'title', e.target.value)}
//                                           disabled={isLoading}
//                                           fontWeight={item.isBold ? 'bold' : 'normal'}
//                                           fontStyle={item.isItalic ? 'italic' : 'normal'}
//                                           color={item.color || '#000000'}
//                                        />
//                                     </Td>
//                                     <Td>
//                                        <Input
//                                           type="number"
//                                           size="sm"
//                                           min="1"
//                                           value={item.orderNo || ''}
//                                           onChange={(e) => handleFieldChange(item.id, 'orderNo', e.target.value)}
//                                           disabled={isLoading}
//                                        />
//                                     </Td>
//                                     <Td>
//                                        <Input
//                                           type="number"
//                                           size="sm"
//                                           min="1"
//                                           value={item.flex || 1}
//                                           onChange={(e) => handleFieldChange(item.id, 'flex', e.target.value)}
//                                           disabled={isLoading}
//                                        />
//                                     </Td>
//                                     <Td>
//                                        <Switch
//                                           isChecked={item.isBold || false}
//                                           onChange={(e) => handleFieldChange(item.id, 'isBold', e.target.checked)}
//                                           disabled={isLoading}
//                                        />
//                                     </Td>
//                                     <Td>
//                                        <Switch
//                                           isChecked={item.isItalic || false}
//                                           onChange={(e) => handleFieldChange(item.id, 'isItalic', e.target.checked)}
//                                           disabled={isLoading}
//                                        />
//                                     </Td>
//                                     <Td>
//                                        <Input
//                                           type="color"
//                                           size="sm"
//                                           width="60px"
//                                           value={item.color || '#000000'}
//                                           onChange={(e) => handleFieldChange(item.id, 'color', e.target.value)}
//                                           disabled={isLoading}
//                                        />
//                                     </Td>
//                                  </Tr>
//                               ))
//                         ) : (
//                            <Tr>
//                               <Td colSpan={8} textAlign="center">
//                                  No data available
//                               </Td>
//                            </Tr>
//                         )}
//                      </Tbody>
//                   </Table>
//                </Box>

//                <HStack justifyContent="flex-end" mt={4}>
//                   <Button variant="outline" onClick={onClose} disabled={isLoading}>
//                      Cancel
//                   </Button>
//                   <Button
//                      colorScheme="blue"
//                      onClick={handleApply}
//                      isLoading={isLoading}
//                      loadingText={isedit ? 'Updating...' : 'Saving...'}>
//                      {isedit ? 'Update Format' : 'Save Format'}
//                   </Button>
//                </HStack>
//             </ModalBody>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default ColumnShowHide;

import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   Table,
   Thead,
   Tbody,
   Tr,
   Th,
   Td,
   Input,
   Button,
   Switch,
   FormControl,
   FormLabel,
   HStack,
   Box,
   useToast,
   useColorMode,
} from '@chakra-ui/react';
import { useState, useEffect, useMemo } from 'react';
import { addReportFormat, getReportFormat, updateReportFormat } from '../../../../redux/actions/reports';
import { useDispatch } from 'react-redux';

const ColumnShowHide = ({
   isOpen,
   onClose,
   data = [],
   onApply,
   isedit,
   editData,
   setShowHideData,
   selectedFormat = null,
   FixdefName1,
   FixdefName2,
   FixdefName3,
   onAddFormat,
   onUpdateFormat,
   staticOption,
   dynamicEditOption,
}) => {
   const dispatch = useDispatch();
   const [columns, setColumns] = useState([]);
   const [formatName, setFormatName] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const toast = useToast();
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   // Determine which FixdefName to use based on staticOption.value
   const getFixdefName = () => {
      const option = staticOption?.value?.toLowerCase()?.trim();

      switch (option) {
         case 'date':
            return FixdefName1;
         case 'party':
            return FixdefName2;
         case 'broker':
            return FixdefName3;
         case 'default':
            return FixdefName1;
         default:
            return staticOption;
      }
   };

   const currentFixdefName = getFixdefName();

   // Helper function to convert hex color to the format expected by the backend
   const hexToColorCode = (hex) => {
      if (!hex || hex === '#000000') return '0xff000000';
      const cleanHex = hex.replace('#', '').toUpperCase();
      return `0xff${cleanHex}`;
   };

   // Helper function to convert color code back to hex
   const colorCodeToHex = (colorCode) => {
      if (!colorCode || colorCode === '0xff000000') return '#000000';
      const hex = colorCode.replace('0xff', '').toLowerCase();
      return `#${hex}`;
   };

   // Memoize the edit mode status and current format
   const { isEditMode, currentFormat } = useMemo(
      () => ({
         isEditMode: Boolean(isedit && editData),
         currentFormat: selectedFormat,
      }),
      [isedit, editData, selectedFormat],
   );

   // Initialize data when modal opens or when dependencies change
   useEffect(() => {
      if (!isOpen) return;

      const initializeData = () => {
         if (isedit && editData) {
            setFormatName(editData.title || editData.defName || '');
            const sourceColumns = editData.viewJson && Array.isArray(editData.viewJson) ? editData.viewJson : data;

            const updated = sourceColumns.map((col, index) => ({
               id: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_') || `col_${index}`,
               defName: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_'),
               title: col.title,
               isShow: col.isShow !== undefined ? col.isShow : true,
               orderNo: col.orderNo !== undefined ? col.orderNo : index + 1,
               flex: col.flex || 1,
               isBold: col.isBold || false,
               color: colorCodeToHex(col.color) || '#000000',
               isItalic: col.isItalic || false,
            }));

            setColumns(updated);
         } else {
            setFormatName('');

            if (data.length) {
               const updated = data.map((col, i) => ({
                  id: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_') || `col_${i}`,
                  defName: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_'),
                  title: col.title,
                  isShow: col.isShow !== undefined ? col.isShow : true,
                  orderNo: col.orderNo !== undefined ? col.orderNo : i + 1,
                  flex: col.flex || 1,
                  isBold: col.isBold || false,
                  color: colorCodeToHex(col.color) || '#000000',
                  isItalic: col.isItalic || false,
               }));
               setColumns(updated);
            } else {
               setColumns([]);
            }
         }
      };

      initializeData();
   }, [isOpen, data, isEditMode, editData]);

   // Toggle show/hide
   const handleToggle = (id) => {
      setColumns((prev) => prev.map((col) => (col.id === id ? { ...col, isShow: !col.isShow } : col)));
   };

   // Updated handleFieldChange
   const handleFieldChange = (id, field, value) => {
      let newValue = value;

      if (field === 'orderNo' || field === 'flex') {
         newValue = parseInt(value) || 0;
      } else if (field === 'color') {
         newValue = value;
      }

      const oldItem = columns.find((col) => col.id === id);
      const oldOrderNo = oldItem?.orderNo;

      let updated = columns.map((col) => (col.id === id ? { ...col, [field]: newValue } : col));

      if (field === 'orderNo') {
         const newOrderNo = newValue;
         const conflictingColumn = columns.find((col) => col.id !== id && col.orderNo === newOrderNo);

         if (conflictingColumn) {
            updated = updated.map((col) => {
               if (col.id === id) {
                  return { ...col, orderNo: newOrderNo };
               } else if (col.orderNo === newOrderNo && col.id !== id) {
                  return { ...col, orderNo: oldOrderNo };
               }
               return col;
            });
         }
      }

      setColumns(updated);
   };

   const handleApply = async () => {
      if (!formatName.trim()) {
         toast({
            title: 'Format name is required',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      const orderNumbers = columns.map((col) => col.orderNo);
      if (new Set(orderNumbers).size !== orderNumbers.length) {
         toast({
            title: 'Order numbers must be unique',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         return;
      }

      const finalColumns = columns
         .map((col) => ({
            defName: col.defName || col.title?.toLowerCase().replace(/\s+/g, '_'),
            title: col.title,
            isShow: col.isShow !== false,
            orderNo: col.orderNo || 0,
            flex: col.flex || 1,
            isBold: col.isBold || false,
            color: hexToColorCode(col.color),
            isItalic: col.isItalic || false,
         }))
         .sort((a, b) => a.orderNo - b.orderNo);

      setIsLoading(true);

      try {
         const isEditing = isedit && editData?.id;

         if (isEditing) {
            const updateData = {
               id: editData.id,
               defName: dynamicEditOption,
               title: formatName,
               viewJson: finalColumns,
            };

            await dispatch(updateReportFormat(updateData));
            await dispatch(getReportFormat());

            if (onUpdateFormat) {
               onUpdateFormat(updateData);
            }
         } else {
            const newFormat = {
               defName: currentFixdefName,
               title: formatName,
               viewJson: finalColumns,
            };

            await dispatch(addReportFormat(newFormat));
            await dispatch(getReportFormat());

            if (onAddFormat) {
               onAddFormat(newFormat);
            }
         }

         if (onApply) {
            onApply(finalColumns);
         }

         if (setShowHideData) {
            setShowHideData(finalColumns);
         }

         onClose?.();
      } catch (error) {
         console.error('Format operation failed:', error);
         toast({
            title: `Error ${isedit ? 'updating' : 'adding'} format`,
            description: error.message || 'Something went wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      } finally {
         setIsLoading(false);
      }
   };

   useEffect(() => {
      if (isOpen && isedit) {
         setFormatName(editData.title);
      }
   }, [isOpen]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
         <ModalOverlay className={isDark ? 'backdrop-blur-sm bg-black/40' : 'backdrop-blur-sm bg-gray-900/20'} />
         <ModalContent
            className={`${
               isDark ? 'bg-gray-900 border-2 border-gray-700' : 'bg-white border-2 border-gray-200'
            } rounded-2xl shadow-2xl`}>
            <ModalHeader
               className={`${
                  isDark
                     ? 'bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-900 text-white border-b-2 border-gray-700'
                     : 'bg-gradient-to-r from-indigo-50 via-purple-50 to-pink-50 text-gray-800 border-b-2 border-indigo-200'
               } rounded-t-2xl py-6 px-6 font-bold text-2xl tracking-tight`}>
               {isedit ? '✏️ Edit Report Format' : '➕ Add New Report Format'}
            </ModalHeader>
            <ModalCloseButton
               className={`${
                  isDark ? 'text-white hover:bg-white/10' : 'text-gray-600 hover:bg-gray-200'
               } rounded-full mt-2 mr-2 transition-all duration-200`}
            />

            <ModalBody className="p-6">
               <FormControl mb={6}>
                  <FormLabel
                     className={`${
                        isDark ? 'text-gray-300' : 'text-gray-700'
                     } font-semibold text-lg mb-2 flex items-center gap-2`}>
                     <span className="text-xl">📝</span> Format Name
                  </FormLabel>
                  <Input
                     value={formatName}
                     onChange={(e) => setFormatName(e.target.value)}
                     placeholder={isedit ? 'Edit format name' : 'Enter format name'}
                     disabled={isLoading}
                     className={`${
                        isDark
                           ? 'bg-gray-800 border-gray-600 text-white placeholder-gray-400 focus:border-indigo-500'
                           : 'bg-gray-50 border-gray-300 text-gray-900 placeholder-gray-400 focus:border-indigo-400'
                     } rounded-xl border-2 transition-all duration-200 text-lg py-6 px-4 hover:shadow-md`}
                     _focus={{
                        boxShadow: isDark ? '0 0 0 3px rgba(99, 102, 241, 0.3)' : '0 0 0 3px rgba(165, 180, 252, 0.3)',
                     }}
                  />
               </FormControl>

               <Box
                  className={`${
                     isDark ? 'bg-gray-800 border-2 border-gray-700' : 'bg-gray-50 border-2 border-gray-200'
                  } rounded-xl overflow-hidden shadow-lg`}>
                  <Box className="overflow-y-auto max-h-[450px] custom-scrollbar">
                     <Table variant="simple" size="sm">
                        <Thead
                           className={`${
                              isDark
                                 ? 'bg-gradient-to-r from-slate-800 to-gray-800 border-b-2 border-gray-600'
                                 : 'bg-gradient-to-r from-indigo-100 to-purple-100 border-b-2 border-indigo-300'
                           } sticky top-0 z-10`}>
                           <Tr>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider py-4`}>
                                 👁️ Show
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 🔤 DefName
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 📌 Title
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 🔢 Order
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 📏 Flex
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 🅱️ Bold
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 🔤 Italic
                              </Th>
                              <Th
                                 className={`${
                                    isDark ? 'text-gray-200 border-gray-700' : 'text-gray-700 border-indigo-200'
                                 } font-bold text-xs uppercase tracking-wider`}>
                                 🎨 Color
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {columns.length > 0 ? (
                              columns
                                 .sort((a, b) => (a.orderNo || 0) - (b.orderNo || 0))
                                 .map((item, index) => (
                                    <Tr
                                       key={item.id}
                                       className={`${
                                          isDark
                                             ? (index % 2 === 0
                                                  ? 'bg-gray-850 hover:bg-gray-800'
                                                  : 'bg-gray-900 hover:bg-gray-800') + ' border-gray-700'
                                             : (index % 2 === 0
                                                  ? 'bg-white hover:bg-indigo-50'
                                                  : 'bg-gray-50 hover:bg-indigo-50') + ' border-gray-200'
                                       } transition-colors duration-150 border-b`}>
                                       <Td className="py-3">
                                          <Switch
                                             isChecked={item.isShow !== false}
                                             onChange={() => handleToggle(item.id)}
                                             disabled={isLoading}
                                             colorScheme="purple"
                                             size="md"
                                          />
                                       </Td>
                                       <Td
                                          className={`${isDark ? 'text-gray-300' : 'text-gray-700'} text-sm`}
                                          fontWeight={item.isBold ? 'bold' : 'normal'}
                                          fontStyle={item.isItalic ? 'italic' : 'normal'}
                                          color={item.color || '#000000'}>
                                          {item.defName}
                                       </Td>
                                       <Td>
                                          <Input
                                             size="sm"
                                             value={item.title}
                                             onChange={(e) => handleFieldChange(item.id, 'title', e.target.value)}
                                             disabled={isLoading}
                                             fontWeight={item.isBold ? 'bold' : 'normal'}
                                             fontStyle={item.isItalic ? 'italic' : 'normal'}
                                             color={item.color || '#000000'}
                                             className={`${
                                                isDark
                                                   ? 'bg-gray-700 border-gray-600 text-white'
                                                   : 'bg-white border-gray-300 text-gray-900'
                                             } rounded-lg border transition-all duration-200 hover:shadow-sm`}
                                          />
                                       </Td>
                                       <Td>
                                          <Input
                                             type="number"
                                             size="sm"
                                             min="1"
                                             value={item.orderNo || ''}
                                             onChange={(e) => handleFieldChange(item.id, 'orderNo', e.target.value)}
                                             disabled={isLoading}
                                             className={`${
                                                isDark
                                                   ? 'bg-gray-700 border-gray-600 text-white'
                                                   : 'bg-white border-gray-300 text-gray-900'
                                             } rounded-lg border transition-all duration-200 hover:shadow-sm w-20`}
                                          />
                                       </Td>
                                       <Td>
                                          <Input
                                             type="number"
                                             size="sm"
                                             min="1"
                                             value={item.flex || 1}
                                             onChange={(e) => handleFieldChange(item.id, 'flex', e.target.value)}
                                             disabled={isLoading}
                                             className={`${
                                                isDark
                                                   ? 'bg-gray-700 border-gray-600 text-white'
                                                   : 'bg-white border-gray-300 text-gray-900'
                                             } rounded-lg border transition-all duration-200 hover:shadow-sm w-20`}
                                          />
                                       </Td>
                                       <Td>
                                          <Switch
                                             isChecked={item.isBold || false}
                                             onChange={(e) => handleFieldChange(item.id, 'isBold', e.target.checked)}
                                             disabled={isLoading}
                                             colorScheme="blue"
                                             size="md"
                                          />
                                       </Td>
                                       <Td>
                                          <Switch
                                             isChecked={item.isItalic || false}
                                             onChange={(e) => handleFieldChange(item.id, 'isItalic', e.target.checked)}
                                             disabled={isLoading}
                                             colorScheme="teal"
                                             size="md"
                                          />
                                       </Td>
                                       <Td>
                                          <Input
                                             type="color"
                                             size="sm"
                                             width="60px"
                                             value={item.color || '#000000'}
                                             onChange={(e) => handleFieldChange(item.id, 'color', e.target.value)}
                                             disabled={isLoading}
                                             className={`${
                                                isDark ? 'bg-gray-700 border-gray-600' : 'bg-white border-gray-300'
                                             } rounded-lg border-2 cursor-pointer hover:shadow-md transition-all duration-200`}
                                          />
                                       </Td>
                                    </Tr>
                                 ))
                           ) : (
                              <Tr>
                                 <Td
                                    colSpan={8}
                                    textAlign="center"
                                    className={`${isDark ? 'text-gray-400' : 'text-gray-500'} py-12 text-lg`}>
                                    📭 No data available
                                 </Td>
                              </Tr>
                           )}
                        </Tbody>
                     </Table>
                  </Box>
               </Box>

               <HStack justifyContent="flex-end" mt={6} spacing={4}>
                  <Button
                     variant="outline"
                     onClick={onClose}
                     disabled={isLoading}
                     className={`${
                        isDark
                           ? 'border-2 border-gray-600 text-gray-300 hover:bg-gray-800 hover:border-gray-500'
                           : 'border-2 border-gray-300 text-gray-700 hover:bg-gray-100 hover:border-gray-400'
                     } rounded-xl px-8 py-6 font-semibold text-lg transition-all duration-200 shadow-md hover:shadow-lg`}>
                     ❌ Cancel
                  </Button>
                  <Button
                     colorScheme="purple"
                     onClick={handleApply}
                     isLoading={isLoading}
                     loadingText={isedit ? 'Updating...' : 'Saving...'}
                     className={`${
                        isDark
                           ? 'bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700'
                           : 'bg-gradient-to-r from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600'
                     } rounded-xl px-8 py-6 font-bold text-lg text-white shadow-lg hover:shadow-xl transition-all duration-200 transform hover:scale-105`}>
                     {isedit ? '✅ Update Format' : '💾 Save Format'}
                  </Button>
               </HStack>
            </ModalBody>
         </ModalContent>

         <style jsx>{`
            .custom-scrollbar::-webkit-scrollbar {
               width: 8px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
               background: ${isDark ? '#1f2937' : '#f3f4f6'};
               border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
               background: ${isDark ? '#4b5563' : '#d1d5db'};
               border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
               background: ${isDark ? '#6b7280' : '#9ca3af'};
            }
         `}</style>
      </Modal>
   );
};

export default ColumnShowHide;
